/**
 * API Section - Landing Page
 */

import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { Card } from '../../../../design-system';

const API = ({ language }) => {
  const isArabic = language === 'ar';
  const [selectedLanguage, setSelectedLanguage] = useState('curl');
  const [copied, setCopied] = useState(false);

  const codeExamples = {
    curl: `curl -X POST "https://safrjal.com/api/v2/send-otp" \\
  -H "X-API-Key: YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{"phone": "962795021746", "otp": "4850", "title": "ودني"}'`,
    javascript: `const response = await fetch('https://safrjal.com/api/v2/send-otp', {
  method: 'POST',
  headers: {
    'X-API-Key': 'YOUR_API_KEY',
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    phone: '962795021746',
    otp: '4850',
    title: 'ودني'
  })
});`,
    python: `import requests

response = requests.post(
  'https://safrjal.com/api/v2/send-otp',
  headers={'X-API-Key': 'YOUR_API_KEY'},
  json={
    'phone': '962795021746',
    'otp': '4850',
    'title': 'ودني'
  }
)`,
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(codeExamples[selectedLanguage]);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section id="api" className="w-full py-16 sm:py-24 md:py-32 lg:py-48 px-3 sm:px-4 bg-[#0B0E14] relative">
      {/* Background accent */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#128C7E]/5 via-transparent to-transparent pointer-events-none" />
      
      <div className="relative max-w-6xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white text-center mb-4 sm:mb-6">
            {isArabic ? 'API سهل الاستخدام' : 'Easy-to-Use API'}
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-[#A0AEC0] max-w-2xl mx-auto leading-relaxed">
            {isArabic ? 'ابدأ التكامل في دقائق' : 'Get started in minutes'}
          </p>
        </div>

        <Card glass className="p-4 sm:p-6 md:p-8 lg:p-12">
          {/* Language Tabs */}
          <div className="flex flex-wrap gap-1 sm:gap-2 mb-6 sm:mb-8 border-b border-[#2D3748] pb-3 sm:pb-4">
            {['curl', 'javascript', 'python'].map((lang) => (
              <button
                key={lang}
                onClick={() => setSelectedLanguage(lang)}
                className={`px-3 sm:px-6 py-2 sm:py-3 font-medium transition-all capitalize rounded-t-lg text-xs sm:text-sm ${
                  selectedLanguage === lang
                    ? 'text-[#128C7E] bg-[#1A1D23] border-b-2 border-[#128C7E]'
                    : 'text-[#A0AEC0] hover:text-white hover:bg-[#1A1D23]/50'
                }`}
              >
                {lang}
              </button>
            ))}
          </div>

          {/* Code Block */}
          <div className="bg-[#010409] rounded-xl p-4 sm:p-6 md:p-8 relative border border-[#2D3748] overflow-hidden">
            <pre className="text-[#A0AEC0] font-mono text-xs sm:text-sm overflow-x-auto leading-relaxed whitespace-pre-wrap break-words">
              <code>{codeExamples[selectedLanguage]}</code>
            </pre>
            <button
              onClick={handleCopy}
              className="absolute top-3 sm:top-6 right-3 sm:right-6 bg-[#128C7E] hover:bg-[#0F8070] text-white p-2 sm:p-3 rounded-lg transition-all duration-200 shadow-lg shadow-[#128C7E]/20 hover:shadow-[#128C7E]/40"
              title={isArabic ? 'نسخ' : 'Copy'}
            >
              {copied ? (
                <Check className="w-4 h-4 sm:w-5 sm:h-5" />
              ) : (
                <Copy className="w-4 h-4 sm:w-5 sm:h-5" />
              )}
            </button>
          </div>
        </Card>
      </div>
    </section>
  );
};

export default API;
